import { isEqual, uniqWith } from "lodash";

export const hasMutationResult = (result: unknown): boolean => {
  if (Array.isArray(result) || typeof result === "string") return result.length > 0;
  if (result !== null && typeof result === "object") return Object.keys(result).length > 0;
  return true;
};

export const deduplicateDateTime = <T>(dateTime: T[]): T[] => uniqWith(dateTime, isEqual);
